export default __webpack_public_path__ + "static/media/category_5.de160897.png";